import { OrderWithReturnableItems } from "@redotech/redo-order-core-common/order";
import { createContext } from "react";

// @ts-expect-error: strict-null-checks
export const OrderContext = createContext<OrderWithReturnableItems>(undefined);

export const ReloadOrderContext = createContext<
  ((skipCache?: boolean) => void) | undefined
>(undefined);
